import { render, staticRenderFns } from "./stuManager.vue?vue&type=template&id=506a7330"
import script from "./stuManager.vue?vue&type=script&lang=js"
export * from "./stuManager.vue?vue&type=script&lang=js"
import style0 from "./stuManager.vue?vue&type=style&index=0&id=506a7330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports